import React from 'react';
import { Flex, Box, BoxProps, Colors, Color } from '@tapresearch/ui/components';
import { keyframes } from '@chakra-ui/react';

export interface DotLoaderProps extends BoxProps {
  dotSize?: `${number}px`;
  dotColor?: Color;
  animationDelayOffset?: number;
}

interface DotProps extends BoxProps {
  animationDelay?: `${number}s`;
}

const grow = keyframes`
  0%, 40%, 100% {
    -webkit-transform: scale(0);
            transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
`;

function Dot({ animationDelay, ...rest }: DotProps) {
  return (
    <Box
      {...{
        position: 'relative',
        borderRadius: 'full',
        animation: `1.2s ${grow} ease-in-out infinite ${animationDelay}`,
      }}
      {...rest}
    />
  );
}

export function DotLoader({
  dotSize = '10px',
  dotColor = Colors.blue[200],
  animationDelayOffset = 0.15,
  ...rest
}: DotLoaderProps) {
  return (
    <Flex alignItems="center" {...rest} data-testid="dot-loader">
      {[0, 1, 2].map((dotNumber) => {
        const animationDelay = `${
          dotNumber * animationDelayOffset
        }s` as `${number}s`;
        return (
          <Dot
            key={`dot-${dotNumber}`}
            animationDelay={animationDelay}
            h={dotSize}
            w={dotSize}
            mr="1"
            bgColor={dotColor}
          />
        );
      })}
    </Flex>
  );
}
